import React from 'react';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import RoundButton from '../RoundButton';
import LayoutContainer from '../LayoutContainer';
import { LocalsearchLogo } from '../../assets/localsearchLogo';
import utmUrl from '../../utils/utmUrl';

const StyledContainer = styled(LayoutContainer)`
  @media (max-width: 1024px) and (orientation: portrait), (max-width: 767px) {
    &.DigitalMarketingBanner__container.LayoutContainer__root {
      padding: 0;
    }
  }
`;

const StyledRoot = styled(Container)`
  padding: 35px 80px 35px 100px;
  background-image: linear-gradient(to bottom, #98b0fd -45%, #2d60fb);
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  border-radius: 11px;
  margin: 40px 0 20px;
  a {
    width: 200px;
    border: 1px solid #ffffff !important;
    font-weight: 600;
  }
  @media (max-width: 1024px) and (orientation: portrait), (max-width: 767px) {
    padding: 35px 30px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 0;
    margin: 0 0 40px;
  }
`;

const StyledDivider = styled(Container)`
  border-right: solid 2px rgba(249, 249, 249, 0.32);
  height: 89px;
  width: 1px;
  margin: 0 40px;

  @media (max-width: 1024px) and (orientation: portrait), (max-width: 767px) {
    border-right: none;
    border-top: solid 2px rgba(249, 249, 249, 0.32);
    width: 200px;
    height: 1px;
    margin: 20px 0 0;
  }
`;

const StyledHeading = styled.h2`
  position: relative;
  top: 0;
  left: 0;
  transform: none;
  font-size: 30px;
  line-height: 1.44em;
  margin: 0 auto 0 0;
  color: #ffffff;
  text-align: left;
  max-width: 364px;
  @media (max-width: 1024px) and (orientation: portrait), (max-width: 767px) {
    font-size: 25px;
    max-width: none;
    text-align: center;
    margin: 30px 0 40px;
  }
`;

const DigitalMarketingBanner = ({ ...props }) => {
  return (
    <div {...props}>
      <StyledContainer className="DigitalMarketingBanner__container">
        <StyledRoot className="DigitalMarketingBanner__root">
          <LocalsearchLogo width={202} height={55} />
          <StyledDivider className="DigitalMarketingBanner__divider" />
          <StyledHeading className="DigitalMarketingBanner__title">
            Bringing calm to the chaos of digital marketing
          </StyledHeading>
          <RoundButton
            href={utmUrl('https://business.localsearch.com.au/', {
              medium: 'home',
              campaign: 'advertise-your-business',
            })}
            target="_blank"
            rel="noopener noreferrer"
            tag="a"
            theme="outlineBlue"
            hoverIcon="icon-generalarrowesmall"
          >
            Get Started
          </RoundButton>
        </StyledRoot>
      </StyledContainer>
    </div>
  );
};

export default DigitalMarketingBanner;
